import CONSTANTS from '../constants';
import { alerts } from './alerts';
import MemberService from '../services/memberService';
import CacheService from '../services/cacheService';

export function fetchMember(history={}) {
    const bname = CacheService.getToken().bname;
	return dispatch => {
		MemberService.getProfile().then((response) => {
		    if(response.data) {
                dispatch(memberAction(response.data));
            } else {
                history.push(`/${bname}/login`);
                dispatch(alerts.error('Member not found'));
            }
		}).catch(() => {
            history.push(`/${bname}/login`);
			dispatch(alerts.error('Member not found'));
		});
	};

	function memberAction(member) { return {type: CONSTANTS.ACTIONS.MEMBER.GET.PROFILE, member: member} }
}

export function fetchMemberships() {
	return dispatch => {
		return MemberService.getMemberships().then((response) => {
			dispatch(membershipsAction(response.data));
		}).catch(() => {
			dispatch(alerts.error('Memberships not found'));
		});
	};

	function membershipsAction(memberships) { return {type: CONSTANTS.ACTIONS.MEMBER.GET.MEMBERSHIPS, memberships: memberships} }
}

export function fetchMembership(membershipId) {
    return dispatch => {
        MemberService.getMembership(membershipId).then((response) => {
            dispatch(membershipAction(response.data));
        }).catch(() => {
            dispatch(alerts.error('Account not found'));
        });
    };

    function membershipAction(membership) { return {type: CONSTANTS.ACTIONS.MEMBER.GET.MEMBERSHIP, membership: membership} }
}

export function fetchAccounts() {
    return dispatch => {
        MemberService.getAccounts().then((response) => {
            dispatch(accountsAction(response.data));
        }).catch(() => {
            dispatch(alerts.error('Accounts not found'));
        });
    };

    function accountsAction(accounts) { return {type: CONSTANTS.ACTIONS.MEMBER.GET.ACCOUNTS, accounts: accounts} }
}

export function fetchAccount(accountId) {
    return dispatch => {
        MemberService.getAccount(accountId).then((response) => {
            dispatch(accountAction(response.data));
        }).catch(() => {
            dispatch(alerts.error('Account not found'));
        });
    };

    function accountAction(account) { return {type: CONSTANTS.ACTIONS.MEMBER.GET.ACCOUNT, account: account} }
}



// WEBPACK FOOTER //
// ./src/actions/members.js